import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import './style.css';
import api from '../../api';

interface ParamTypes {
  token: string;
}

const ConfirmAccount = () => {
  const { token } = useParams<ParamTypes>();
  const [returnedMessage, setReturnedMessage] = useState('');
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await api.get(`/users/confirm-email/${token}`);
      setReturnedMessage('Conta ativada com sucesso.');
      setTimeout(() => {
        history.push('/login');
      }, 1500);
    })().catch((error) => {
      setReturnedMessage(
        error?.response?.data?.msg || 'Não foi possível confirmar sua conta.'
      );
    });
  }, [token]);

  return (
    <div>
      <h1 className='returned-message'>
        {!returnedMessage
          ? 'Aguarde enquanto verificamos sua conta'
          : returnedMessage}
      </h1>
    </div>
  );
};

export default ConfirmAccount;
